import React from 'react';
import OwlCarousel from 'react-owl-carousel';  
import { Link } from 'react-router-dom';

export default function Home_banner() {
  return (
    <>	
	<div id="slider-one" className="main-slider-area">
		<div className="slider-bg">
			
				<OwlCarousel items={1}  
				className="owl-theme"  
				loop 
				dots={false}			  
				margin={8} >
					<div className="item">
						<div className="container">
							<div className="row align-items-center">
								<div className="col-xl-6 col-lg-6 order-last order-lg-first">
									<div className="slider__content">
										<p className="pretitle-p">Next level automation system</p>
										<h1 className="main-title-one">For Tech <span className="d-xxl-block fw-bold">IT
												Solutions</span></h1>
										<p className="aftertitle-p">We provide Website design ,Website Development , cheap
											Domain and
											hosting, reliable hosting server, Software Development</p>
										<Link className="theme_btn" to="/contact">Get Started Now</Link>
									</div>
								</div>
								<div className="col-xl-6 col-lg-6 d-flex align-items-end justify-content-center">
									<div className="slider-right text-center">
									<img className="d-none d-lg-block" src="assets/img/slider/hero-man-2.png" alt="Hero Img" />
									<img className="d-md-inline-block d-lg-none" src="assets/img/slider/hero-man-2.png"
											alt="Hero Img" />
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="item">
						<div className="container">
							<div className="row align-items-center">
								<div className="col-xl-6 col-lg-6 order-last order-lg-first">
									<div className="slider__content">
										<p className="pretitle-p">VR Project Management Software For Teams</p>
										<h1 className="main-title-one">Measure
											Performance<span className="d-xxl-block fw-bold"></span></h1>
										<p className="aftertitle-p">We provide Website design ,Website Development , cheap
											Domain and
											hosting, reliable hosting server, Software Development</p>
											<Link className="theme_btn" to="/contact">Get Started Now</Link>
									</div>
								</div>
								<div className="col-xl-6 col-lg-6 d-flex align-items-end justify-content-center">
									<div className="slider-right text-center">
										<img className="d-none d-lg-block" src="assets/img/slider/hero-man-1.png" alt="Hero Img" />
										<img className="d-md-inline-block d-lg-none" src="assets/img/slider/hero-man-1.png"
											alt="Hero Img" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</OwlCarousel>
			</div>
		</div>
	
    </>
  )
}
